//#region Helper Methods

export function HasDigit(value: string | number) {
    let chars = new String(value).split("");
    return chars.some(x => x.charCodeAt(0) >= "0".charCodeAt(0) && x.charCodeAt(0) <= "9".charCodeAt(0));
}
export function HasLower(value: string | number) {
    let chars = new String(value).split("");
    return chars.some(x => x.charCodeAt(0) >= "a".charCodeAt(0) && x.charCodeAt(0) <= "z".charCodeAt(0));
}
export function HasUpper(value: string | number) {
    let chars = new String(value).split("");
    return chars.some(x => x.charCodeAt(0) >= "A".charCodeAt(0) && x.charCodeAt(0) <= "Z".charCodeAt(0));
}
export function HasLetterOrDigit(value: string | number) {
    let chars = new String(value).split("");
    return chars.every(x => HasUpper(x) || HasLower(x) || HasDigit(x));
}
export function DistinctChars(value: string | number) {
    return new String(value)
        .split("")
        .filter((item, i, ar) => {
            return ar.indexOf(item) === i;
        })
        .join("");
}

//#endregion